export default {
  // 已有文本
  'pages.dashboard.text':
    'Seamlessly integrates with store management ecosystem, providing remote point management solutions.',
  'pages.dashboard.storeTitle': 'Stores',
  'pages.dashboard.management.title': 'Head Office Management',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': 'Show Member Registration QR Code',
  'pages.dashboard.qrcode.title': 'Member Registration QR Code',
  'pages.dashboard.qrcode.download': 'Download QR Code',
  'pages.dashboard.qrcode.close': 'Close',

  // 其他已有文本
  'pages.dashboard.tooltip.members': 'Members',
  'pages.dashboard.tooltip.cards': 'Gift Cards',
  'pages.dashboard.tooltip.coupons': 'Vouchers',
  'pages.dashboard.tooltip.orders': 'Orders',

  'pages.dashboard.userApp.management.title': 'User App Management',
  'pages.dashboard.userApp.posters.button': 'Post Manager',
  'pages.dashboard.userApp.posters.title': 'Post Manager',
  'pages.dashboard.userApp.posters.add': 'Add Poster',
  'pages.dashboard.userApp.posters.edit': 'Edit Poster',
  'pages.dashboard.userApp.posters.noPermission.title': 'No Permission',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    'You do not have permission to access User App promotional poster management for this head office.',
  'pages.dashboard.userApp.posters.upload.imageTypeError':
    'Only jpg, png, or webp images can be uploaded',
  'pages.dashboard.userApp.posters.upload.sizeError': 'Image size cannot exceed 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': 'Please upload a poster image',
  'pages.dashboard.userApp.posters.message.saveSuccess': 'Saved successfully',
  'pages.dashboard.userApp.posters.message.deleteSuccess': 'Deleted successfully',
  'pages.dashboard.userApp.posters.empty.all': 'No posters',
  'pages.dashboard.userApp.posters.empty.carousel': 'No top carousel posters',
  'pages.dashboard.userApp.posters.empty.static': 'No static posters',
  'pages.dashboard.userApp.posters.delete.confirm': 'Delete this poster?',
  'pages.dashboard.userApp.posters.delete.ok': 'Delete',
  'pages.dashboard.userApp.posters.delete.cancel': 'Cancel',
  'pages.dashboard.userApp.posters.type.carousel': 'Carousel Poster',
  'pages.dashboard.userApp.posters.type.static': 'Static Poster',
  'pages.dashboard.userApp.posters.sort': 'Sort',
  'pages.dashboard.userApp.posters.section.carousel': 'Top Carousel Posters',
  'pages.dashboard.userApp.posters.section.static': 'Static Posters',
  'pages.dashboard.userApp.posters.form.title': 'Poster Title',
  'pages.dashboard.userApp.posters.form.title.required': 'Please enter a poster title',
  'pages.dashboard.userApp.posters.form.title.placeholder': 'Example: Weekend Sale',
  'pages.dashboard.userApp.posters.form.displayType': 'Poster Type',
  'pages.dashboard.userApp.posters.form.displayType.required': 'Please select a poster type',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    'Carousel poster (top auto carousel, recommended 1536 x 860)',
  'pages.dashboard.userApp.posters.form.displayType.static':
    'Static poster (lower list, recommended 1536 x 560)',
  'pages.dashboard.userApp.posters.form.sortOrder': 'Carousel Order',
  'pages.dashboard.userApp.posters.form.sortOrder.required': 'Please select carousel order',
  'pages.dashboard.userApp.posters.form.sortOrder.page': 'Page {value}',
  'pages.dashboard.userApp.posters.form.image': 'Poster Image',
  'pages.dashboard.userApp.posters.form.image.replace': 'Replace Image (optional)',
  'pages.dashboard.userApp.posters.form.image.select': 'Select Image',
  'pages.dashboard.userApp.posters.scope.common': 'Common Posters',
  'pages.dashboard.userApp.posters.scope.store': 'Store Posters',
  'pages.dashboard.userApp.posters.store.placeholder': 'Select a Store',
  'pages.dashboard.userApp.posters.store.viewOnly':
    'View only — Store Poster management permission required',
  'pages.dashboard.userApp.catalog.tab': 'Catalog',
  'pages.dashboard.userApp.catalog.current': 'Current Catalog',
  'pages.dashboard.userApp.catalog.none': 'No Catalog published',
  'pages.dashboard.userApp.catalog.replace': 'Replace Catalog',
  'pages.dashboard.userApp.catalog.upload': 'Upload Catalog',
  'pages.dashboard.userApp.catalog.title': 'Title',
  'pages.dashboard.userApp.catalog.dates': 'Display period (Sydney time)',
  'pages.dashboard.userApp.catalog.pdf': 'PDF',
  'pages.dashboard.userApp.catalog.select': 'Select PDF',
  'pages.dashboard.userApp.catalog.entryImage': 'Catalog cover image',
  'pages.dashboard.userApp.catalog.entryImageHint': 'Recommended: 1200 × 360 px.',
  'pages.dashboard.userApp.catalog.selectImage': 'Select image',
  'pages.dashboard.userApp.catalog.invalidImage': 'Select a JPG, PNG or WebP image up to 20 MB',
  'pages.dashboard.userApp.catalog.publish': 'Publish Catalog',
  'pages.dashboard.userApp.catalog.replacePublish': 'Replace and publish',
  'pages.dashboard.userApp.catalog.delete': 'Delete',
  'pages.dashboard.userApp.catalog.confirm': 'Delete this Catalog?',
  'pages.dashboard.userApp.catalog.open': 'Open PDF',
  'pages.dashboard.userApp.catalog.pages': '{count} pages',
  'pages.dashboard.userApp.catalog.processing': 'Processing Catalog {done} / {total} pages',
  'pages.dashboard.userApp.catalog.failed': 'Processing failed: {error}',
  'pages.dashboard.userApp.catalog.issues': 'Scheduled Catalogs',
  'pages.dashboard.userApp.catalog.active': 'Live',
  'pages.dashboard.userApp.catalog.edit': 'Edit',
  'pages.dashboard.userApp.catalog.save': 'Save',
  'pages.dashboard.userApp.catalog.saved': 'Catalog saved',
  'pages.dashboard.userApp.catalog.removed': 'Catalog deleted',
  'pages.dashboard.userApp.catalog.queued': 'Catalog is processing',
  'pages.dashboard.userApp.catalog.required': 'Enter a title and select a PDF and cover image',
  'pages.dashboard.userApp.catalog.invalidPeriod': 'Select a valid start and end date and time',
  'pages.dashboard.userApp.catalog.invalidPdf': 'Select a PDF up to 30 MB',
  'pages.dashboard.userApp.catalog.loadFailed': 'Could not load Catalogs',
  'pages.dashboard.userApp.catalog.uploadFailed': 'Catalog upload failed',
  'pages.dashboard.userApp.catalog.saveFailed': 'Could not save Catalog',
  'pages.dashboard.userApp.catalog.removeFailed': 'Could not remove Catalog',
  'pages.dashboard.userApp.catalog.libraryTab': 'Catalog Library',
  'pages.dashboard.userApp.catalog.libraryHint': 'Shared by all stores. Add a catalog to a layout in Home Layout.',
  'pages.dashboard.userApp.catalog.moveUp': 'Move up',
  'pages.dashboard.userApp.catalog.moveDown': 'Move down',
  'pages.dashboard.userApp.catalog.status.live': 'Live',
  'pages.dashboard.userApp.catalog.status.scheduled': 'Scheduled',
  'pages.dashboard.userApp.catalog.status.ended': 'Ended',
  'pages.dashboard.userApp.layout.tab': 'Home Layout',
  'pages.dashboard.userApp.layout.loadFailed': 'Could not load the home layout',
  'pages.dashboard.userApp.layout.discardConfirm': 'Discard unsaved layout changes?',
  'pages.dashboard.userApp.layout.discard': 'Discard',
  'pages.dashboard.userApp.layout.keepEditing': 'Keep editing',
  'pages.dashboard.userApp.layout.saved': 'Layout published to the app',
  'pages.dashboard.userApp.layout.saveFailed': 'Could not publish the layout',
  'pages.dashboard.userApp.layout.pickCatalog': 'Select a catalog',
  'pages.dashboard.userApp.layout.needImage': 'Add at least one image',
  'pages.dashboard.userApp.layout.invalidImage': 'Select a JPG, PNG or WebP image up to 5 MB',
  'pages.dashboard.userApp.layout.uploadFailed': 'Image upload failed',
  'pages.dashboard.userApp.layout.type.carousel': 'Carousel',
  'pages.dashboard.userApp.layout.type.poster': 'Poster',
  'pages.dashboard.userApp.layout.type.catalog': 'Catalog',
  'pages.dashboard.userApp.layout.catalogMissing': 'Catalog not found',
  'pages.dashboard.userApp.layout.carouselMeta': '{count} of {max} images · auto-scrolls every {seconds}s',
  'pages.dashboard.userApp.layout.posterMeta': 'Single image · full width',
  'pages.dashboard.userApp.layout.previewHeader': 'Home',
  'pages.dashboard.userApp.layout.previewEmpty': 'Nothing to show',
  'pages.dashboard.userApp.layout.dragHandle': 'Drag to reorder',
  'pages.dashboard.userApp.layout.status.live': 'Live',
  'pages.dashboard.userApp.layout.status.scheduled': 'Scheduled',
  'pages.dashboard.userApp.layout.status.ended': 'Ended',
  'pages.dashboard.userApp.layout.moveUp': 'Move up',
  'pages.dashboard.userApp.layout.moveDown': 'Move down',
  'pages.dashboard.userApp.layout.hide': 'Hide in app',
  'pages.dashboard.userApp.layout.show': 'Show in app',
  'pages.dashboard.userApp.layout.edit': 'Edit',
  'pages.dashboard.userApp.layout.removeConfirm': 'Remove this block from the layout?',
  'pages.dashboard.userApp.layout.remove': 'Remove',
  'pages.dashboard.userApp.layout.catalog': 'Catalog',
  'pages.dashboard.userApp.layout.noCatalogs': 'Upload a catalog in Catalog Library first',
  'pages.dashboard.userApp.layout.blockName': 'Block name',
  'pages.dashboard.userApp.layout.blockNameHint': 'Only shown in the back office.',
  'pages.dashboard.userApp.layout.interval': 'Auto-scroll every',
  'pages.dashboard.userApp.layout.seconds': '{seconds} seconds',
  'pages.dashboard.userApp.layout.imagesCount': 'Images ({count} of {max})',
  'pages.dashboard.userApp.layout.image': 'Image',
  'pages.dashboard.userApp.layout.slide': 'Slide {index}',
  'pages.dashboard.userApp.layout.replaceImage': 'Click or drop an image to replace',
  'pages.dashboard.userApp.layout.uploadImages': 'Click or drop images to add',
  'pages.dashboard.userApp.layout.carouselImageHint': 'Recommended 1536 × 860. JPG, PNG or WebP up to 5 MB.',
  'pages.dashboard.userApp.layout.posterImageHint': 'Recommended 1536 × 560. JPG, PNG or WebP up to 5 MB.',
  'pages.dashboard.userApp.layout.layoutFor': 'Layout for',
  'pages.dashboard.userApp.layout.scope.common': 'Common (all stores)',
  'pages.dashboard.userApp.layout.scope.store': 'Store layout',
  'pages.dashboard.userApp.layout.storePlaceholder': 'Select a store',
  'pages.dashboard.userApp.layout.useCommon': 'Use common layout',
  'pages.dashboard.userApp.layout.viewOnly': 'View only',
  'pages.dashboard.userApp.layout.lastPublished': 'Last published {time} by {user}',
  'pages.dashboard.userApp.layout.unsaved': 'Unsaved changes',
  'pages.dashboard.userApp.layout.publish': 'Save & publish',
  'pages.dashboard.userApp.layout.usingCommon': 'This store shows the common layout. Untick "Use common layout" to give this store its own layout.',
  'pages.dashboard.userApp.layout.blocksTitle': 'Home screen blocks',
  'pages.dashboard.userApp.layout.blocksHint': '{count} blocks · drag the handle or use the arrows to reorder',
  'pages.dashboard.userApp.layout.preview': 'App preview',
  'pages.dashboard.userApp.layout.previewHint': 'Hidden blocks and catalogs outside their display period are not shown.',
  'pages.dashboard.userApp.layout.addBlock': 'Add block',
  'pages.dashboard.userApp.layout.editBlock': 'Edit block',
  'pages.dashboard.userApp.layout.cancel': 'Cancel',
  'pages.dashboard.userApp.layout.done': 'Done',
  'pages.dashboard.userApp.layout.empty': 'No blocks yet. Add a carousel, poster or catalog.',
};
